export default __webpack_public_path__ + "static/media/profile.bcdc17b5.jpeg";